import api from './axios';

const EndPoints = {
	marketSetting: `/merchant/market-setting`,
	marketPairs: `/merchant/market-setting/pairs`,
};

export const getMarketSettings = async (params: Record<string, any>) => {
	const filteredParams: Record<string, any> = {};
	for (const key in params) {
		if (Object.prototype.hasOwnProperty.call(params, key) && params[key]) {
			filteredParams[key] = params[key];
		}
	}
	const res = await api.get(EndPoints.marketSetting, { params: filteredParams });
	return res;
};

export const getMarketPairs = async () => {
	const res = await api.get(EndPoints.marketPairs);
	console.log(res, "res")
	return res;
};
